/**
 * Created by spepa on 16.11.2022
 */

const Landmarks = function () {
    this.received = [];

    if (cleverapps.achievements) {
        cleverapps.achievements.on("complete", this.onAchievementComplete.bind(this), this);
    }
};

Landmarks.prototype.destructor = function () {
    runCleaners(this);
};

Landmarks.prototype.onAchievementComplete = function (config) {
    if (typeof QuestsWindow !== "undefined" && QuestsWindow.IsAvailable()) {
        new Reward("units", config, { toMainWorld: true, withoutDelta: true }).receiveReward();

        this.landmarkReceived(config);
    }
};

Landmarks.prototype.process = function () {
    this._giveMissed();
    this.processFresh();
};

Landmarks.prototype.processFresh = function () {
    if (cleverapps.focusManager.isFocused() || !cleverapps.environment.isMainScene() || !Families.landmark) {
        return;
    }

    const location = cleverapps.meta.getSelectedLocation();
    if (location.locationConfig.isMain) {
        let education;
        const opened = Achievements.listGatheredUnits("landmark");
        if (opened.length === 1) {
            education = this.getFirstOneEd();
        }
        if (opened.length === 2) {
            education = this.getReplaceEd();
        }

        if (education) {
            cleverapps.focusManager.display({
                focus: "LandmarksEducation",
                action: education
            });
            return;
        }
    }

    while (this.received.length) {
        const landmarkData = this.received.shift();
        if (typeof QuestsWindow !== "undefined" && QuestsWindow.IsAvailable()) {
            cleverapps.focusManager.display({
                focus: "LandmarkReceived",
                action: function (f) {
                    new QuestsWindow({
                        achievementToCollect: landmarkData
                    });
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
            return;
        }

        if (landmarkData.dialogue) {
            this.showDialogue(landmarkData.dialogue);
            return;
        }
    }
};

Landmarks.prototype.canDeploy = function (unit) {
    if (this.findLocation()) {
        return this.listDeployable().map(Unit.GetKey).includes(Unit.GetKey(unit));
    }
    return false;
};

Landmarks.prototype.showDialogue = function (steps) {
    cleverapps.focusManager.display({
        focus: "LandmarkReceived",
        action: function (f) {
            const dialogue = new Dialogue(steps, {
                showUp: true,
                autoClose: true
            });

            dialogue.on("afterClose", f);
            new DialogueView(dialogue);
        }
    });
};

Landmarks.prototype.listDeployed = function () {
    const deployed = [];
    const region = Map2d.currentMap.regions.landmarks;
    if (region) {
        for (let i = 0; i < region.positions.length; i++) {
            const landmark = Map2d.currentMap.getUnit(region.positions[i].x, region.positions[i].y);
            if (landmark && landmark.getType() === "landmark") {
                deployed.push(landmark);
            }
        }
    }
    return deployed;
};

Landmarks.prototype.listDeployable = function () {
    const open = Achievements.listGatheredUnits("landmark");
    const deployed = this.listDeployed();
    return cleverapps.substract(open, deployed, (unit) => Unit.GetKey(unit));
};

Landmarks.prototype.findLocation = function () {
    let locations = Map2d.currentMap.regions.landmarks && Map2d.currentMap.regions.landmarks.positions;
    if (!locations) {
        return;
    }
    locations = locations.filter((loc) => !Map2d.currentMap.getFog(loc.x, loc.y));

    const getOrder = function (location) {
        const unit = Map2d.currentMap.getUnit(location.x, location.y);
        if (unit && unit.getType() === "landmarkspot") {
            return 0;
        }
        return !unit ? 1 : 2;
    };

    return locations.sort((a, b) => getOrder(a) - getOrder(b))[0];
};

Landmarks.prototype.construct = function (data, location) {
    location = location || this.findLocation();
    const curUnit = Map2d.currentMap.getUnit(location.x, location.y);
    if (curUnit) {
        (curUnit.findComponent(Landmark) || curUnit.findComponent(LandmarkSpot)).onRemove();
        curUnit.remove(true);
    }

    const newUnit = new Unit({
        code: data.code,
        stage: data.stage
    });
    newUnit.setPosition(location.x, location.y);
    Map2d.currentMap.add(Map2d.LAYER_UNITS, newUnit.x, newUnit.y, newUnit);
    Map2d.currentMap.onAddUnit(newUnit.x, newUnit.y, newUnit);
    (newUnit.findComponent(Landmark) || newUnit.findComponent(LandmarkSpot)).onCreate();

    return newUnit;
};

Landmarks.prototype.replaceActions = function (unit) {
    return [
        function (f) {
            if (unit.code === "landmarkspot") {
                const newUnit = this.listDeployable()[0];
                if (newUnit) {
                    unit = this.construct(newUnit, { x: unit.x, y: unit.y });
                }
            }
            f();
        }.bind(this),

        function (f) {
            Map2dScroller.currentScroller.zoomIn(unit, {
                position: cleverapps.UI.DOCK_LEFT | cleverapps.UI.DOCK_RIGHT,
                padding: cleverapps.styles.LandmarkSelectWindow.scrollToUnitPadding,
                callback: f
            });
        },

        function (f) {
            const wasShown = cleverapps.dataLoader.load(DataLoader.TYPES.LANDMARK_INFO);
            if (wasShown) {
                f();
                return;
            }
            cleverapps.dataLoader.save(DataLoader.TYPES.LANDMARK_INFO, true);
            new GuideWindow(this.getGuideWindowOptions());
            cleverapps.focusManager.onceNoWindowsListener = f;
        }.bind(this),

        function (f) {
            Map2d.currentMap.highlightUnit(unit, f);
        },

        function (f) {
            const WindowCtor = cleverapps.config.ui === "wooden" ? WoodenUILandmarkSelectWindow : LandmarkSelectWindow;
            const selectWindow = new WindowCtor(unit.findComponent(Landmark) || unit.findComponent(LandmarkSpot));
            selectWindow.addCleaner(() => {
                if (Map2d.currentMap) {
                    Map2d.currentMap.unhighlightUnit();
                }
            });
            cleverapps.focusManager.onceNoWindowsListener = f;
        },

        function (f) {
            Map2dScroller.currentScroller.zoomOut();
            Map2d.currentMap.unhighlightUnit();
            f();
        }
    ];
};

Landmarks.prototype.getFirstOneEd = function () {
    if (this.listDeployed().length > 0) {
        return;
    }

    const location = this.findLocation();
    const curUnit = location && Map2d.currentMap.getUnit(location.x, location.y);
    if (!curUnit || !curUnit.findComponent(LandmarkSpot)) {
        return;
    }

    return function (f) {
        const landmark = this.construct(Achievements.listGatheredUnits("landmark")[0], location);
        cleverapps.focusManager.compound(f, this.replaceActions(landmark));
    }.bind(this);
};

Landmarks.prototype.getReplaceEd = function () {
    if (cleverapps.forces.isShown(Forces.SECOND_LANDMARK)) {
        return;
    }
    const deployed = this.listDeployed()[0];
    if (!deployed) {
        cleverapps.forces.saveForce(Forces.SECOND_LANDMARK);
        return this.getFirstOneEd();
    }

    const newUnit = this.listDeployable()[0];
    const newLandmark = this.construct(newUnit, this.findLocation());

    return function (f) {
        cleverapps.forces.saveForce(Forces.SECOND_LANDMARK);
        cleverapps.focusManager.compound(f, this.replaceActions(newLandmark));
    }.bind(this);
};

Landmarks.prototype.listWindowLandmarks = function (initialLandmark) {
    let landmarks = [];

    const location = cleverapps.meta.getSelectedLocation();
    const landmarksOnMap = Landmarks.ONMAP[location.locationId];
    if (landmarksOnMap) {
        landmarks = landmarks.concat(landmarksOnMap);
    }

    const activeLocations = cleverapps.meta.listActiveLocations();

    AchievementsConfig.listUnitAchievements().forEach((config) => {
        if (cleverapps.achievements.isGathered(config.id) || !config.expedition || cleverapps.meta.isLocationAvailable(config.expedition) || activeLocations.includes(config.expedition)) {
            if (!config.available || cleverapps.user.checkAvailable(config.available)) {
                landmarks.push(config);
            }
        }
    });
    const initialKey = initialLandmark && initialLandmark.unit && Unit.GetKey(initialLandmark.unit);

    landmarks = landmarks.filter((landmark) => {
        const isDeployable = this.canDeploy(landmark);
        const isSelected = initialKey && Unit.GetKey(landmark) === initialKey;
        const isInActiveLocation = activeLocations.includes(landmark.expedition);
        const isStickersPrize = typeof StickersBook2 !== "undefined" && StickersBook2.isMainPrizeLandmark(landmark);

        return (landmark.targetExpedition || "main") === location.locationId
            && (!Landmarks.isUnattainable(landmark) || cleverapps.achievements.isGathered(landmark.id))
            && (isDeployable || isSelected || isInActiveLocation || isStickersPrize);
    });
    landmarks.sort((landmark1, landmark2) => {
        const landmark1Location = landmark1.expedition && cleverapps.meta.getLocationMeta(landmark1.expedition);
        const landmark2Location = landmark2.expedition && cleverapps.meta.getLocationMeta(landmark2.expedition);
        if (landmark1Location && landmark2Location && landmark1Location.isFinished() && landmark2Location.isFinished()) {
            return landmark1Location.getFinishTime() < landmark2Location.getFinishTime() ? -1 : 1;
        }
        return landmark1.stage < landmark2.stage ? -1 : 1;
    });

    return landmarks;
};

Landmarks.prototype.canGiveLandmark = function (config) {
    return cleverapps.achievements.canGiveAchievement(config);
};

Landmarks.prototype.isActiveDonor = function (donor) {
    return cleverapps.achievements.isActiveDonor(donor);
};

Landmarks.prototype.needToReplaceDonor = function (donor) {
    const config = cleverapps.achievements.findDonorConfig(donor);
    if (config && config.feature) {
        return !cleverapps.achievements.isActiveDonor(donor);
    }
};

Landmarks.prototype.getDonorReplacer = function (donor) {
    if (this.needToReplaceDonor(donor)) {
        return UnitsLibrary.LastStage(donor.code).stage === donor.stage ? { code: "coins", stage: 2 } : { code: "coins", stage: 0 };
    }
};

Landmarks.prototype.getTimeLeft = function (config) {
    return cleverapps.achievements.getTimeLeft(config);
};

Landmarks.prototype.getGuideWindowOptions = function (config) {
    return config && config.guide
        || cleverapps.skins.getSlot("landmarkGuideOptions")
        || { name: "LandmarkGuideWindow", bundle: bundles.landmarkguidewindow };
};

Landmarks.prototype.findDonorLandmark = function (donor) {
    return cleverapps.achievements.findDonorConfig(donor);
};

Landmarks.prototype.isOnMap = function (config) {
    const data = Landmarks.ONMAP[config.expedition];
    return data && data.some((landmark) => Unit.IsApplicable(config, landmark));
};

Landmarks.prototype.landmarkReceived = function (config) {
    this.received.push(config);
};

Landmarks.prototype._restoreOnMap = function () {
    const currentPage = cleverapps.meta.selectedLocationId();
    if (Landmarks.ONMAP[currentPage]) {
        const onMap = {}, onMapOpen = {};
        Landmarks.ONMAP[currentPage].forEach((landmark) => {
            onMap[landmark.code] = onMap[landmark.code] || [];
            onMap[landmark.code].push(landmark.stage);
        });

        Map2d.currentMap.fogs.listFakeUnits().forEach((fake) => {
            if (onMap[fake.code] && onMap[fake.code].includes(fake.stage) && !Map2d.currentMap.getFog(fake.x, fake.y)) {
                onMapOpen[fake.code] = onMapOpen[fake.code] || [];
                onMapOpen[fake.code].push(fake.stage);
            }
        });

        for (const code in onMapOpen) {
            onMapOpen[code].forEach((stage) => {
                cleverapps.unitsLibrary.openUnit({ code, stage });
            });
        }
    }
};

Landmarks.prototype._restorePreview = function () {
    Map2d.currentMap.fogs.listFakeUnits().forEach((fake) => {
        if (fake.code === "landmarkpreview" && !Map2d.currentMap.getFog(fake.x, fake.y)) {
            const curUnit = Map2d.currentMap.getUnit(fake.x, fake.y);
            if (!curUnit || !Unit.IsApplicable(curUnit, fake)) {
                const unit = new Unit(fake);
                unit.move(fake.x, fake.y);
                Map2d.currentMap.onAddUnit(unit.x, unit.y, unit);
                Map2d.currentMap.onUnitAvailable(unit);
            }
        }
    });
};

Landmarks.prototype._restore = function () {
    const map = Map2d.currentMap;
    const regions = map.regions.landmarks && map.regions.landmarks.positions;
    if (!regions || !Families.landmarkspot) {
        return;
    }

    map.listAvailableUnits([{ type: "landmark" }, { type: "landmarkspot" }]).forEach((unit) => {
        const inRegion = regions.some((region) => unit.x === region.x && unit.y === region.y);
        if (!inRegion) {
            unit.remove();
        }
    });

    regions.forEach((region) => {
        if (map.getFog(region.x, region.y)) {
            return;
        }
        cleverapps.unitsLibrary.openUnit({ code: "landmarkspot", stage: 0 });

        let unit = map.getUnit(region.x, region.y);
        if (!unit || ["landmarkspot", "landmark"].indexOf(unit.getType()) === -1) {
            unit = new Unit({ code: "landmarkspot", stage: 0 });
            unit.move(region.x, region.y);
            map.onAddUnit(region.x, region.y, unit);
        }
    });
};

Landmarks.prototype.restoreLandmarks = function () {
    if (!cleverapps.gameModes.skipRestoreLandmarks) {
        this._restoreOnMap();
        this._restorePreview();
        this._restore();
    }
};

Landmarks.prototype._giveMissed = function () {
    if (this.missedGiven || cleverapps.focusManager.isFocused()) {
        return;
    }

    const configs = AchievementsConfig.listByExpedition(cleverapps.meta.selectedLocationId());
    if (!configs.length) {
        return;
    }

    const toGive = configs.filter(this.canGiveLandmark.bind(this));
    if (!toGive.length) {
        return;
    }
    this.missedGiven = true;
    cleverapps.focusManager.display({
        focus: "LandmarksEducation",
        action: function (f) {
            new RewardWindow({ units: toGive }, { toMainWorld: true });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

Landmarks.prototype.openLandmark = function (landmarkData) {
    if (!landmarkData.targetExpedition) {
        // a landmark handed out as a plain { code, stage } reward carries no target of its own -
        // the achievement entry for that stage is where the landmark is described
        landmarkData = Landmarks.getLandmarkData(landmarkData.stage) || landmarkData;
    }

    if (!landmarkData.targetExpedition) {
        cleverapps.throwAsync(`no target expedition page for landmark ${landmarkData.code} ${landmarkData.stage}`);
        return;
    }

    if (cleverapps.achievements) {
        const achievementConfig = AchievementsConfig.findByUnit(landmarkData);
        if (achievementConfig) {
            cleverapps.achievements.grant(achievementConfig.id);
        }
    }

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.LANDMARKS.OPEN + landmarkData.code}_${landmarkData.stage}`);
};

Landmarks.isUnattainable = function (landmark) {
    return landmark.donors && landmark.donors.length === 0;
};

Landmarks.getLandmarkData = function (stage) {
    return AchievementsConfig.findByUnit({ code: "landmark", stage });
};

Landmarks.initialize = function () {
    for (const expedition in Landmarks.ONMAP) {
        const data = Landmarks.ONMAP[expedition];

        for (let i = 0; i < data.length; ++i) {
            const landmark = data[i];

            landmark.expedition = expedition;
        }
    }
};

Landmarks.ONMAP = {};
